import { Outlet } from 'react-router';

import {
  GENERAL_SETTINGS_PERMISSION_ACTIONS,
  GENERAL_SETTINGS_PERMISSIONS,
} from '@/console/features/general-settings/general-settings.permissions';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const generalSettingsRoutes: TCustomRouteObject = {
  path: '/general-settings',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'general-settings',
      localized: true,
    },
    permission: {
      action: GENERAL_SETTINGS_PERMISSION_ACTIONS,
      any: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { GeneralSettingsRoute } = await import('./general-settings');
        return { Component: GeneralSettingsRoute };
      },
    },
    {
      path: 'manage-company',
      lazy: async () => {
        const { ManageCompanyRoute } = await import('./manage-company');
        return { Component: ManageCompanyRoute };
      },
      handle: {
        crumb: {
          label: 'manage_company',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.manageCompany,
        },
      },
    },
    {
      path: 'webhooks',
      lazy: async () => {
        const { WebhooksRoute } = await import('./webhooks');
        return { Component: WebhooksRoute };
      },
      handle: {
        crumb: {
          label: 'webhooks',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.webhooks,
        },
      },
    },
    {
      path: 'integrations',
      lazy: async () => {
        const { IntegrationsRoute } = await import('./integrations');
        return { Component: IntegrationsRoute };
      },
      handle: {
        crumb: {
          label: 'integrations',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.integrations,
        },
      },
    },
    {
      path: 'tags',
      lazy: async () => {
        const { TagsRoute } = await import('./tags');
        return { Component: TagsRoute };
      },
      handle: {
        crumb: {
          label: 'tags',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.tags,
        },
      },
    },
    {
      path: 'backup-lifecycle',
      lazy: async () => {
        const { BackupLifecycleRoute } = await import('./backup-lifecycle');
        return { Component: BackupLifecycleRoute };
      },
      handle: {
        crumb: {
          label: 'backup_lifecycle',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.backupLifecycle,
        },
      },
    },
    {
      path: 'ideaas',
      lazy: async () => {
        const { IdeaasSettingsRoute } = await import('./ideaas');
        return { Component: IdeaasSettingsRoute };
      },
      handle: {
        crumb: {
          label: 'ideaas_hub_settings',
          localized: true,
        },
        permission: {
          action: GENERAL_SETTINGS_PERMISSIONS.ideaas,
        },
      },
    },
    {
      path: 'subscription/:tabId?',
      lazy: async () => {
        const { SubscriptionRoute } = await import('./subscription');
        return { Component: SubscriptionRoute };
      },
      handle: {
        crumb: {
          label: 'subscription',
          localized: true,
        },
      },
    },
  ],
};
